import React from 'react';

const IconBenefits = (props) => (
  <svg width={100} height={100} viewBox="-30 -30 550 550" {...props}>
    <path d="M256 64c105.875 0 192 86.125 192 192s-86.125 192-192 192S64 361.875 64 256 150.125 64 256 64m0-32C132.281 32 32 132.281 32 256s100.281 224 224 224 224-100.281 224-224S379.719 32 256 32zm-64 112c-17.688 0-32 21.5-32 48 0 26.531 14.313 48 32 48s32-21.469 32-48c0-26.5-14.312-48-32-48zm128 0c-17.688 0-32 21.5-32 48 0 26.531 14.313 48 32 48s32-21.469 32-48c0-26.5-14.312-48-32-48zm79.375 148.469c2.469-8.469-2.406-17.344-10.906-19.844-8.469-2.531-17.344 2.438-19.844 10.875C354.125 333.25 307.813 368 256 368s-98.125-34.75-112.641-84.5c-2.469-8.438-11.25-13.406-19.844-10.875-8.484 2.5-13.344 11.375-10.875 19.844C131.109 355.781 190.063 400 256 400s124.875-44.219 143.375-107.531z" />
  </svg>
);

export default IconBenefits;
